import React from 'react';
import styles from './Modals.module.css';
import Close from 'Utils/Assets/SVGs/Close';

interface PrivacyPolicyModalProps {
  modalVisibility: boolean;
  closeModal: () => void;
  updateCheckBoxState: (agree: boolean) => void;
}

const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({
  modalVisibility,
  closeModal,
  updateCheckBoxState,
}) => {
  if (!modalVisibility) return null;

  const agreeToPolicy = () => {
    updateCheckBoxState(true);
    closeModal();
  };

  return (
    <div className={styles.modalBackdrop} data-testid="modal-backdrop">
      <div className={styles.modalContainer} data-testid="modal-container">
        <button
          className={styles.modalClose}
          onClick={closeModal}
          aria-label="Close"
          data-testid="close-button"
        >
          <Close width={24} height={24} />
        </button>

        <div className={styles.modalScroll} data-testid="modal-scroll">
          <h2 className={styles.modalTitle} data-testid="modal-title">
            Privacy Policy
          </h2>

          <h3 className={styles.sectionTitle}>1. Introduction</h3>
          <p className={styles.text}>
            We are committed to protecting your privacy. This policy explains how we collect, use, and safeguard your personal information when you interact with our services.
          </p>

          <h3 className={styles.sectionTitle}>2. Information We Collect</h3>
          <p className={styles.text}>
            • Personal information such as your name, email address, and phone number<br />
            • Technical information including your IP address, operating system, and device type
          </p>

          <h3 className={styles.sectionTitle}>3. How We Use Your Information</h3>
          <p className={styles.text}>
            • To enhance and improve our services<br />
            • To comply with legal obligations<br />
            • To provide technical support and resolve issues
          </p>

          <h3 className={styles.sectionTitle}>4. Data Security</h3>
          <p className={styles.text}>
            We implement appropriate security measures to protect your data. However, no method of electronic transmission or storage is entirely secure.
          </p>

          <h3 className={styles.sectionTitle}>5. Your Rights</h3>
          <p className={styles.text}>
            • You may access, review, and update your personal information<br />
            • You may withdraw your consent at any time, subject to applicable laws
          </p>

          <button
            type="button" 
            className={styles.modalAgree}
            onClick={agreeToPolicy}
            data-testid="agree-button"
          >
            I Agree
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
